// Utility to get all currencies with code, symbol, and name
import currencyCodes from 'currency-codes';
import getSymbolFromCurrency from 'currency-symbol-map';

// Returns array: [{ code, symbol, currency, countries }]
export function getAllCurrencies() {
  return currencyCodes.data.map(c => ({
    code: c.code,
    symbol: getSymbolFromCurrency(c.code) || c.code,
    currency: c.currency,
    countries: c.countries
  }));
}
